import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Dict from 'dict-lib';
import {Button, ListGroup, Modal, Row} from 'react-bootstrap';
import FontAwesome from "react-fontawesome";
import {LexemeUtilities, LexemeEditingLevel,} from "../lexeme/page/editor/LexemeHelper";
import stylesSearchPage from '../_css/dictionary/searchPage.module.css';
import BUtils from './../utilities/BaseUtilities';


export class SearchExportModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nPage: 1,
            pageText: document.getElementById("export-split-part1").innerHTML,
            show: true
        };

        this.groups = document.getElementsByClassName('export-split-part');
        this.rawGroups = document.getElementsByClassName('export-struct-split-part');
    }

    _movePages(direction) {

        var nPage = this.state.nPage;
        if (direction === 'next')
            nPage++;
        else
            nPage--;

        if (nPage > 0 && nPage <= this.groups.length) {
            var pageText = document.getElementById('export-split-part' + nPage).innerHTML;
            this.setState({
                nPage,
                pageText
            })
        }
    };


    render() {

        var pagesButton = '';
        if (this.groups.length > 1) {
            pagesButton = <>
                <Button bsSize="large"
                        onClick={() => this._movePages('prev')}><FontAwesome name={"arrow-left"}/></Button>
                <span
                    className={stylesSearchPage['span-export-page-counter']}>{this.state.nPage + '/' + this.groups.length}</span>
                <Button bsSize="large"
                        onClick={() => this._movePages('next')}><FontAwesome name={"arrow-right"}/></Button>
            </>;
        }

        const content = <div id="modal-div-html-container">
            <Row id="modal-row-html-container" dangerouslySetInnerHTML={{__html: this.state.pageText}}>
            </Row>
            <Row id="modal-row-html-buttons">
                {pagesButton}
                <Button bsSize="large"
                        onClick={() => {
                            var json = '';
                            for (let group of this.rawGroups) {
                                json += group.innerHTML;
                            }
                            LexemeUtilities.downloadJson(json, 'strutture');
                        }
                        }>{Dict.t('DOWNLOAD_JSON')}</Button>
                <Button bsSize="large"
                        onClick={() => {
                            var html = '';
                            for (let group of this.groups) {
                                html += group.innerHTML;
                            }
                            LexemeUtilities.downloadHtml(html, 'schede');
                        }
                        }>{Dict.t('DOWNLOAD_HTML')}</Button>
                <Button bsSize="large"
                        onClick={() => {
                            var html = '';
                            for (let group of this.groups) {
                                html += group.innerHTML;
                            }
                            LexemeUtilities.downloadPdf(html, 'schede');
                        }
                        }>{Dict.t('DOWNLOAD_PDF')}</Button>
                <Button bsSize="large"
                        onClick={() => {
                            this.setState({show: false});
                        }}>{Dict.t('CLOSE')}</Button>
            </Row>
        </div>;

        return <Modal
            className={BUtils.joinClasses("modal-message", stylesSearchPage["modal-message-downloadable-html"])}
            dialogClassName={stylesSearchPage["modal-dialog-message-downloadable-html"]} show={this.state.show}
            restoreFocus>

            <Modal.Body className={stylesSearchPage["modal-body-message-downloadable-html"]}>
                {content}
            </Modal.Body>
        </Modal>;
    }
}